import ApplicationForm from './applicationForm';
import Loader from './loader';
import PlaystoreMobileAd from '@scaler_landing/utils/playstoreMobileAd';
import registerEvent from './registerEvent';
import {
  AnalyticsReportStrip, RcbBackdrop,
} from '@common/vanilla_ui/general';
import MobileHeaderSticky
  from '@scaler_landing/components/mobileHeaderSticky';
import MidfunnelRcb
  from '@scaler_landing/pages/events/midfunnel_rcb_blocker';

// after the HTML DOM has been rendered
const formId = 'events-application-form';
const formFlowEl = document.querySelector(`#${formId}`);

document.addEventListener('DOMContentLoaded', () => {
  const lazyImages = [].slice.call(
    document.querySelectorAll('img.lazy, img.lazy-elem'),
  );

  // add gtm tracking - pageview
  window.addEventListener('tracking_initialized', () => {
    window.TrackingHelper?.setContext('mix_panel_data', {
      product: 'event',
      subproduct: 'listing_page',
    });
  });

  if ('IntersectionObserver' in window) {
    // eslint-disable-next-line no-unused-vars
    const lazyImageObserver = new IntersectionObserver((entries, observer) => {
      // if an image intersects with viewport
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove('lazy');
          lazyImage.classList.remove('lazy-elem');
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    // observe for all images when the images intersects the viewport
    lazyImages.forEach(lazyImage => {
      lazyImageObserver.observe(lazyImage);
    });
  }
  MobileHeaderSticky.initialize();
  Loader.initialize();
  registerEvent.initialize();
  RcbBackdrop.initialize({
    elements: [
      '#main-site-header',
      '.event-page',
      '.footer',
      '#request-callback-strip',
    ],
  });
  AnalyticsReportStrip.initialize();
});

window.addEventListener('load', () => {
  if (formFlowEl) new ApplicationForm('events-application-form');
  PlaystoreMobileAd.initialize();
  MidfunnelRcb.initialize();
});
